import {
    Box,
    Grid,
    Heading,
    Text
} from '@theme-ui/components'
import { Container, Markdown } from '~/Common'
import { useTranslation } from 'react-i18next'

export const IndicativeTimetable = ({ bg = 'white', data, sx, container, ...props }) => {
    const { t } = useTranslation();
    const title = data?.title ?? null;
    const description = data?.description ?? null;

    return (
        <Box bg={bg} {...props} sx={{
            position: 'relative',
            ...sx
        }}>
            <Container variant="layouts.section" {...container}>
                { title && <Heading as="h2" variant="content_block_heading">{t(title)}</Heading>}
                { description && (
                    <Box className="markdown" mb={[4,4,5]} sx={{ fontWeight: 500, fontSize: '19px' }}>
                        <Markdown>{description}</Markdown>
                    </Box>
                )}

                {data?.cards && (
                    <Box sx={{
                        width: '100%',
                        mb: 0,
                    }}>
                        {data.cards.map((card, key) => (
                            <Box key={key} mb={3}>
                                <Grid sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(12, 1fr)',
                                    width: '100%',
                                    mb: '40px',
                                }}>
                                    <Text as="p" variant="small" color="dark" mb={1} sx={{ gridColumn: 'span 5', alignContent: 'center', }} >{card?.label}</Text>
                                    <Text as="p" variant="h3" color="darker" sx={{ fontWeight: 500, fontSize: [2, 3], gridColumn: 'span 7', alignContent: 'center' }}>{card?.value}</Text>
                                </Grid>
                            </Box>
                        ))}
                    </Box>
                )}
            </Container>
        </Box>
    )
};
